import React from 'react';
import { Timer } from 'lucide-react';

/** Today's date (YYYY-MM-DD) as seen in the race's timezone, so the count flips at local midnight there. */
const todayIn = (timezone: string): string =>
  new Intl.DateTimeFormat('en-CA', { timeZone: timezone, year: 'numeric', month: '2-digit', day: '2-digit' }).format(
    new Date(),
  );

export const daysUntil = (raceDate: string, timezone: string): number => {
  const msPerDay = 1000 * 60 * 60 * 24;
  return Math.round((Date.parse(raceDate) - Date.parse(todayIn(timezone))) / msPerDay);
};

const RaceCountdown: React.FC<{ raceDate: string; timezone: string; detail: string }> = ({
  raceDate,
  timezone,
  detail,
}) => {
  const daysToRace = daysUntil(raceDate, timezone);

  let label: string;
  let sub = detail;
  if (daysToRace > 1) {
    label = `${daysToRace} days to gun`;
  } else if (daysToRace === 1) {
    label = 'Tomorrow';
  } else if (daysToRace === 0) {
    label = 'Race day';
    sub = 'Today';
  } else {
    label = `${Math.abs(daysToRace)} days since`;
    sub = 'Recovery phase';
  }

  return (
    <div className="race-countdown">
      <Timer size={15} />
      <span className="race-countdown-label">{label}</span>
      <span className="race-countdown-sep">·</span>
      <span className="race-countdown-detail">{sub}</span>
    </div>
  );
};

export default RaceCountdown;
